import React from "react";
import { About } from '../components/About';

const AboutPage = () => (
  <div className="pt-8">
    <About />
  </div>
);

export default AboutPage;